<template>
  <div>
    <b-row>
      <b-col xl="6" lg="12">
        <b-card no-body >
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerFertilizaciones(this.semana_sig.toString(),this.semana.toString(),this.year_actual)"
                      id="act_semSgte"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-tooltip
                      title="Actualizar Tabla"
                      target="act_semSgte"
                  />

                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="false"
                      v-b-modal.modal-importar
                      id="imp_semSgte"
                  >
                    <font-awesome-icon icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-tooltip
                      title="Importar Registros"
                      target="imp_semSgte"
                  />
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana anterior N° ${this.semana_sig}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana_sig} al ${this.finSemana_sig}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Rendimiento Semanal Re')"
              hover
              responsive
              outlined
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="itemsSemAnterior"
              :fields="fieldsSemActual"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tablas."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <!--
            <template #cell(fecha_n)="data">
              {{ data.value }} @ {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
            </template>
            -->

            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(nuevo_cosecha)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(nombre_empresa)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(dni_trabajador)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(nombres_trabajador)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(fecha_ingreso)="data">
              <span style="white-space: nowrap">{{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}</span>
            </template>
            <template #cell(categoria_rango)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>

            <template #cell(valor_minimo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(valor_maximo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(valor_condicion_rango_redondeo)="data">
              <span style="white-space: nowrap">{{ data.value }}  %</span>
            </template>
            <template #cell(resultado_condicion_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(dia_tareo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }}</span>
            </template>
            <template #cell(valor_desviacion_estandar_muestral_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }}</span>
            </template>

            <template #cell(promedio_cumplimiento_cuadrilla_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>




          </b-table>



        </b-card>
      </b-col>
      <b-col xl="6" lg="12">
        <b-card no-body >
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="traerFertilizaciones(this.semana_sig.toString(),this.semana.toString(),this.year_actual)"
                      id="act_semAct"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-tooltip
                      title="Actualizar Tabla"
                      target="act_semAct"
                  />

                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-b-modal.modal-importar
                      id="imp_semAct"
                      v-if="false"
                  >
                    <font-awesome-icon icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-tooltip
                      title="Importar Registros"
                      target="imp_semAct"
                  />
                </b-button-group>
              </b-col>
              <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana actual N° ${this.semana}`}}</span><br>
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana} al ${this.finSemana}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table
              v-if="$can('read', 'Rendimiento Semanal Re')"
              hover
              responsive
              outlined
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="itemsSemActual"
              :fields="fieldsSemActual"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tablas."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <!--
            <template #cell(fecha_n)="data">
              {{ data.value }} @ {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
            </template>
            -->

            <template #table-busy>
              <div class="text-center text-dark my-2">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>


            <template #cell(nuevo_cosecha)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(nombre_empresa)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(dni_trabajador)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(nombres_trabajador)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>
            <template #cell(fecha_ingreso)="data">
              <span style="white-space: nowrap">{{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}</span>
            </template>
            <template #cell(categoria_rango)="data">
              <span style="white-space: nowrap">{{ data.value }}</span>
            </template>

            <template #cell(valor_minimo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(valor_maximo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(valor_condicion_rango_redondeo)="data">
              <span style="white-space: nowrap">{{ data.value }}  %</span>
            </template>
            <template #cell(resultado_condicion_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>
            <template #cell(dia_tareo_rango)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }}</span>
            </template>
            <template #cell(valor_desviacion_estandar_muestral_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }}</span>
            </template>

            <template #cell(promedio_cumplimiento_cuadrilla_rango_redondeo)="data">
              <span style="white-space: nowrap"  v-if="data.value==''">0.00 %</span>
              <span style="white-space: nowrap"  v-else>{{ data.value }} %</span>
            </template>


          </b-table>



        </b-card>
      </b-col>
    </b-row>

  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner
} from 'bootstrap-vue'
import axios from "axios";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRowsSemActual: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      src: '',
      fieldsSemActual: [

        {
          key: 'nombre_empresa',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'dni_trabajador',
          label: 'dni trabajador',
          sortable: true
        },
        {
          key: 'nombres_trabajador',
          label: 'nombres trabajador',
          sortable: true
        },
        {
          key: 'fecha_ingreso',
          label: 'fecha ingreso',
          sortable: true
        },
        {
          key: 'dia_tareo_rango',
          label: 'día tareo rango',
          sortable: true
        },
        {
          key: 'promedio_cumplimiento_cuadrilla_rango_redondeo',
          label: 'promedio rango',
          sortable: true
        },
        {
          key: 'categoria_rango',
          label: 'categoria rango',
          sortable: true
        },
        {
          key: 'valor_minimo_rango',
          label: 'minimo rango',
          sortable: true
        },
        {
          key: 'valor_maximo_rango',
          label: 'maximo_rango',
          sortable: true
        },

        {
          key: 'valor_desviacion_estandar_muestral_rango_redondeo',
          label: 'Desviación estándar rango',
          sortable: true
        },
        {
          key: 'valor_condicion_rango_redondeo',
          label: 'condición rango',
          sortable: true
        },
        {
          key: 'resultado_condicion_rango_redondeo',
          label: 'resultado condición',
          sortable: true
        },
        {
          key: 'nuevo_cosecha',
          label: 'Estado',
          sortable: true
        },
      ],
      itemsSemActual: [],
      itemsSemAnterior:[],
      loading: false,
      status: [
        {
          1: 'Nuevo',
          2: 'Antiguo',
          3: 'Sin contrato',
        },
        {
          1: 'light-success',
          2: 'light-warning',
          3: 'light-danger',
        }
      ],
      semana_sig: null,
      inicioSemana_sig: null,
      finSemana_sig: null,

      inicioSemana: null,
      finSemana:null,
      semana: null,

      year_actual:0,

    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.dataInicial();
    this.leerListaNegra();
  },
  methods: {
    leerListaNegra(){
      var yo = this

      yo.loading = true


      var semana_actual = 33;
      var semana_anterior = 32;
      var year_actual = 2022;
      var config = {
        method: 'get',
        url: '/cosecha/cosecha/rendiemiento/semanal/?semana_actual='+semana_actual+'&semana_anterior='+semana_anterior+'&year_actual='+year_actual,
        headers: { }
      };


      axiosIns(config)
          .then((response) => {
            yo.itemsSemActual = response.data.response_actual;
            yo.itemsSemAnterior = response.data.response_anterior;
            yo.totalRowsSemActual = yo.itemsSemActual.length

          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
      });

    },
    cPaginacion(filteredItems) {
      this.totalRowsSemActual = filteredItems.length
      this.currentPage = 1
    },
    dataInicial(){

      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      var year_actual = spd.inicio.toLocaleString('pe-PE', {
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      });
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana - 1
      spd.inicio.setDate(spd.inicio.getDate() - 7)
      spd.fin.setDate(spd.fin.getDate() - 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.year_actual= year_actual;
      //  this.traerFertilizaciones(this.semana_sig.toString(),this.semana.toString(),this.year_actual);



    },
    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },


  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
